module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "LeafletMap",
    style: (_vm.styles),
    attrs: {
      "id": this.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cab8213"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/map/LeafletMap.vue
// module id = 708
// module chunks = 0